import { apiSlice } from './apiSlice';
import { CHECKOUT_URL } from '../constants';

export const checkoutApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // Prices the bag server-side and opens a Stripe Checkout Session
        createCheckoutSession: builder.mutation({
            query: ({ orderItems, promoCode }) => ({
                url: `${CHECKOUT_URL}/session`,
                method: 'POST',
                body: { orderItems, promoCode },
            }),
        }),
        // Fulfils the order if Stripe says it's paid; returns { status, orderId }
        getCheckoutSessionStatus: builder.query({
            query: (sessionId) => ({
                url: `${CHECKOUT_URL}/session-status`,
                params: { session_id: sessionId },
            }),
            keepUnusedDataFor: 0,
        }),
    }),
});

export const {
    useCreateCheckoutSessionMutation,
    useLazyGetCheckoutSessionStatusQuery,
} = checkoutApiSlice;
